/**
 * What the sentinel saw, and no more: the page's heartbeat stopped with no clean
 * unload mark, and a later load found it. Out of memory is one cause; a force
 * quit, a dead battery or a reload whose mark was lost look the same from here.
 * Only the browser's own report (pages/api/errors/browser-report) can say "out of
 * memory". Until 2026-11-04 this read "Tab killed while open (probable out of
 * memory)", a guess shown as a fact in the checkout stories.
 */
export const TAB_ENDED_MESSAGE = 'Tab ended without unloading (cause unknown)';

/** The pre-2026-11-04 wording, still on older error_logs rows. */
export const LEGACY_TAB_ENDED_MESSAGE = 'Tab killed while open (probable out of memory)';

/** The story text for an error message: the old guess reads as what was seen. */
export function factualErrorMessage(message: string): string {
  return message === LEGACY_TAB_ENDED_MESSAGE ? TAB_ENDED_MESSAGE : message;
}
